import { lazy } from "react";

const loaders = {
  Login: () => import("@/pages/Login"),
  ForgotPassword: () => import("@/pages/ForgotPassword"),
  ResetPassword: () => import("@/pages/ResetPassword"),
  AuditLog: () => import("@/pages/AuditLog"),
  Dashboard: () => import("@/pages/Dashboard"),
  Etablissements: () => import("@/pages/Etablissements"),
  EtablissementDetail: () => import("@/pages/EtablissementDetail"),
  Sites: () => import("@/pages/Sites"),
  Locaux: () => import("@/pages/Locaux"),
  Equipements: () => import("@/pages/Equipements"),
  EquipementPassport: () => import("@/pages/EquipementPassport"),
  Autorisations: () => import("@/pages/Autorisations"),
  DossierArsn: () => import("@/pages/DossierArsn"),
  Referentiel: () => import("@/pages/Referentiel"),
  Checkups: () => import("@/pages/Checkups"),
  NonConformites: () => import("@/pages/NonConformites"),
  PlanAction: () => import("@/pages/PlanAction"),
  Documents: () => import("@/pages/Documents"),
  ServicesCEP: () => import("@/pages/ServicesCEP"),
  Prospects: () => import("@/pages/Prospects"),
  Opportunites: () => import("@/pages/Opportunites"),
  Pipeline: () => import("@/pages/Pipeline"),
  Utilisateurs: () => import("@/pages/Utilisateurs"),
  Parametres: () => import("@/pages/Parametres"),
  Profil: () => import("@/pages/Profil"),
  Travailleurs: () => import("@/pages/Travailleurs"),
  TravailleurDetail: () => import("@/pages/TravailleurDetail"),
};

export const Pages = Object.fromEntries(
  Object.entries(loaders).map(([name, load]) => [name, lazy(load)])
);

const ROUTE_TO_PAGE = {
  "/": "Dashboard",
  "/etablissements": "Etablissements",
  "/sites": "Sites",
  "/locaux": "Locaux",
  "/equipements": "Equipements",
  "/autorisations": "Autorisations",
  "/referentiel": "Referentiel",
  "/checkup": "Checkups",
  "/non-conformites": "NonConformites",
  "/plan-action": "PlanAction",
  "/documents": "Documents",
  "/services": "ServicesCEP",
  "/prospects": "Prospects",
  "/opportunites": "Opportunites",
  "/pipeline": "Pipeline",
  "/utilisateurs": "Utilisateurs",
  "/journal-audit": "AuditLog",
  "/parametres": "Parametres",
  "/profil": "Profil",
  "/travailleurs": "Travailleurs",
};

export const preloadRoute = (path) => {
  const name = ROUTE_TO_PAGE[path];
  if (name) loaders[name]();
};
